"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectSmall = exports.LargeSelect = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _helpers = require("../../helpers");

var _Box = require("../Box");

var _Input = require("../Input");

var _Typography = require("../Typography");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var computeOptionTags = function computeOptionTags(options, name) {
  var optionTags = options.map(function (option, index) {
    var text = option.text,
        value = option.value;
    var key = [name || "", value || index].join("-");
    return _react.default.createElement("option", {
      value: value,
      key: key
    }, text);
  });
  return optionTags;
};

/**
 * A large drop-down select menu
 */
var LargeSelect = function LargeSelect(props) {
  var description = props.description,
      disabled = props.disabled,
      error = props.error,
      name = props.name,
      onSelect = props.onSelect,
      options = props.options,
      required = props.required,
      selected = props.selected,
      title = props.title;
  var optionTags = computeOptionTags(options, name);
  return _react.default.createElement(_Box.Box, {
    width: "100%"
  }, title && _react.default.createElement(_Typography.Serif, {
    mb: "0.5",
    size: "3"
  }, title, required && _react.default.createElement(_Input.Required, null, "*")), description && _react.default.createElement(_Typography.Serif, {
    color: "black60",
    mb: "1",
    size: "2"
  }, description), _react.default.createElement(LargeSelectContainer, _extends({}, props, {
    p: 1
  }), _react.default.createElement("select", {
    disabled: disabled,
    name: name,
    onChange: function onChange(event) {
      return onSelect && onSelect(event.target.value);
    },
    value: selected
  }, optionTags)), error && _react.default.createElement(_Typography.Sans, {
    color: "red100",
    mt: "1",
    size: "2"
  }, error));
};

exports.LargeSelect = LargeSelect;
LargeSelect.displayName = "LargeSelect";

/**
 * A small version of drop-down select menu
 */
var SelectSmall = function SelectSmall(props) {
  var disabled = props.disabled,
      onSelect = props.onSelect,
      options = props.options,
      selected = props.selected,
      title = props.title;
  var optionTags = computeOptionTags(options);
  return _react.default.createElement(SelectSmallContainer, props, _react.default.createElement("label", null, props.title && _react.default.createElement(_Typography.Sans, {
    size: "2",
    display: "inline",
    mr: 0.5
  }, title, ":"), _react.default.createElement("select", {
    disabled: disabled,
    onChange: function onChange(event) {
      return onSelect && onSelect(event.target.value);
    },
    value: selected
  }, optionTags)));
};

exports.SelectSmall = SelectSmall;
SelectSmall.displayName = "SelectSmall";
var hideDefaultSkin = (0, _styledComponents.css)(["background:none;border:none;cursor:pointer;outline:0;-webkit-appearance:none;-moz-appearance:none;text-indent:0.01px;text-overflow:\"\";&:-moz-focusring{color:transparent;text-shadow:0 0 0 #000;}option:not(:checked){color:black;}"]);
var carretSize = 4;
var caretArrow = (0, _styledComponents.css)(["border-left:", "px solid transparent;border-right:", "px solid transparent;border-top:", "px solid ", ";width:0;height:0;"], carretSize, carretSize, carretSize, function (props) {
  return props.disabled ? (0, _helpers.color)("black10") : (0, _helpers.color)("black100");
});

var LargeSelectContainer = _styledComponents.default.div.withConfig({
  displayName: "Select__LargeSelectContainer",
  componentId: "sc-1weszjl-0"
})(["position:relative;width:100%;select{width:100%;font-family:", ";font-size:", "px;line-height:", "px;height:40px;", ";border:1px solid ", ";border-radius:0;transition:border-color 0.25s;padding-right:", "px;cursor:", ";", ";&:hover{border-color:", ";}&:focus{border-color:", ";}}&::after{content:\"\";cursor:", ";pointer-events:none;position:absolute;top:45%;right:", "px;", ";}"], (0, _styledSystem.themeGet)("fontFamily.serif.regular"), (0, _styledSystem.themeGet)("typeSizes.serif.3.fontSize"), (0, _styledSystem.themeGet)("typeSizes.serif.3t.lineHeight"), hideDefaultSkin, function (_ref) {
  var disabled = _ref.disabled,
      error = _ref.error;
  return (0, _helpers.color)((0, _Input.computeBorderColor)({
    disabled: disabled,
    error: !!error
  }));
}, (0, _helpers.space)(1), function (props) {
  return props.disabled ? "default" : "pointer";
}, _styledSystem.space, function (_ref2) {
  var disabled = _ref2.disabled,
      error = _ref2.error;
  return (0, _helpers.color)((0, _Input.computeBorderColor)({
    disabled: disabled,
    error: !!error,
    pseudo: "hover"
  }));
}, function (_ref3) {
  var disabled = _ref3.disabled,
      error = _ref3.error;
  return (0, _helpers.color)((0, _Input.computeBorderColor)({
    disabled: disabled,
    error: !!error,
    pseudo: "focus"
  }));
}, function (props) {
  return props.disabled ? "default" : "pointer";
}, (0, _helpers.space)(1), caretArrow);

var SelectSmallContainer = _styledComponents.default.div.withConfig({
  displayName: "Select__SelectSmallContainer",
  componentId: "sc-1weszjl-1"
})(["position:relative;label{", ";padding:0;margin:0;}select{", ";background-color:", ";border-radius:2px;", ";font-size:", "px;line-height:", "px;padding:", "px ", "px ", "px ", "px;", ";", ";&:hover{background-color:", ";}&:focus{border-color:", ";}}&::after{", ";content:\"\";cursor:pointer;margin-left:-", "px;pointer-events:none;position:absolute;top:", "px;}"], _styledSystem.width, hideDefaultSkin, (0, _helpers.color)("black10"), (0, _styledSystem.themeGet)("fontFamily.sans.medium"), (0, _styledSystem.themeGet)("typeSizes.sans.2.fontSize"), (0, _styledSystem.themeGet)("typeSizes.sans.2.lineHeight"), (0, _helpers.space)(0.5), (0, _helpers.space)(1) + carretSize * 4, (0, _helpers.space)(0.5), (0, _helpers.space)(1), _styledSystem.space, _styledSystem.width, (0, _helpers.color)("black30"), (0, _helpers.color)("purple100"), caretArrow, (0, _helpers.space)(1) + carretSize * 2, 5 + (0, _helpers.space)(0.5));
//# sourceMappingURL=Select.js.map